import { render, staticRenderFns } from "./GongHuoTabPage.vue?vue&type=template&id=61e17038&scoped=true&"
import script from "./GongHuoTabPage.vue?vue&type=script&lang=js&"
export * from "./GongHuoTabPage.vue?vue&type=script&lang=js&"
import style0 from "./GongHuoTabPage.vue?vue&type=style&index=0&id=61e17038&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e17038",
  null
  
)

export default component.exports